// extracted by mini-css-extract-plugin
module.exports = {"title":"WhereToGoSection_title__V2Yfw","mapContainer":"WhereToGoSection_mapContainer___sPzg","mapWrapper":"WhereToGoSection_mapWrapper__r_DjX","map":"WhereToGoSection_map__Uq2kC"};